import script from "./CitiesFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CitiesFooter.vue?vue&type=script&setup=true&lang=js"

import "./CitiesFooter.vue?vue&type=style&index=0&id=1810cf26&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1810cf26"]])

export default __exports__